export default () => ({
  '& tr': {
    '& .grid-edit-icon': {
      fontSize: '14px',
      lineHeight: '16px',
      color: '#005A9E', // @shade20: #005a9e;
      visibility: 'visible',
      position: 'static',
      opacity: 0,

      '&:hover': {
        cursor: 'pointer',
      },
      '&:focus': {
        visibility: 'visible',
        opacity: 100,
      },
    },

    '&:hover .grid-edit-icon': {
      visibility: 'visible',
      opacity: 100,
    },

    '&:hover .grid-column-Status .statuschangehover': {
      '&:before': {
        display: 'inline-block',
      },
      '&:hover': {
        cursor: 'pointer',
      },
    },
    '& .grid-column-Status .statuschangehover:before': {
      display: 'none',
    },
  },
});
